import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { GridModule, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { CollapseButtonComponent } from 'src/app/base/shared/collapse-button/collapse-button.component';
import { ThemeShowcaseGridRow, themeShowcaseGridData } from '../utils/theme-showcase-data';

@Component({
  selector: 'app-theme-grid-showcase',
  templateUrl: './theme-grid-showcase.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, GridModule, ToolbarModule, CollapseButtonComponent]
})
export class ThemeGridShowcaseComponent {
  @Input() public isExpanded = true;
  @Output() public toggleExpand = new EventEmitter<void>();
  public readonly pageSettings: PageSettingsModel = { pageSize: 5 };
  public readonly gridData: ThemeShowcaseGridRow[] = themeShowcaseGridData;

  public toggle(): void {
    this.toggleExpand.emit();
  }
}
